export default __webpack_public_path__ + "static/media/hide.ceb3d1d1.png";